// Material UI
import { Grid, Chip, Icon } from '@mui/material';

// Componentes
import BasicSelect from '@components/Selects/BasicSelect';
import TextFieldTK from '@components/Form/TextFieldTK';

// Utils
import { getFormikUtil } from '@utils/Utilities';

// Data
import { SI_NO } from '@data/constants/catalogs';

const InvitationForm = (props) => {
  const { isLoading, formik, showChip = true } = props;

  const getFormik = (value) => getFormikUtil(formik, 'invitation', value);

  return (
    <Grid container spacing={3}>
      {showChip && (
        <Grid item xs={12}>
          <Chip icon={<Icon>mail</Icon>} label="Invitación" />
        </Grid>
      )}

      {/* <Grid item xs={12} md={4} lg={6}>
        <BasicSelect
          size="small"
          name="invitation.idInvite"
          label="¿Te gustaría invitar a alguien más?"
          options={SI_NO}
          value={getFormik('idInvite')?.value}
          onChange={formik.handleChange}
          isLoading={isLoading}
          error={getFormik('idInvite').error}
          errorMessage={getFormik('idInvite').helperText}
          sx={{ width: '100%' }}
        />
      </Grid> */}

      <Grid item xs={12} md={8} lg={6}>
        <BasicSelect
          size="small"
          name="invitation.idTrainer"
          label="¿Te gustaría se capacitador voluntario de alguna habilidad o conocimiento que tengas?"
          options={SI_NO}
          value={getFormik('idTrainer')?.value}
          onChange={formik.handleChange}
          isLoading={isLoading}
          error={getFormik('idTrainer').error}
          errorMessage={getFormik('idTrainer').helperText}
          sx={{ width: '100%' }}
        />
      </Grid>

      {getFormik('idTrainer')?.value === 1 && (
        <Grid item xs={12} md={4} lg={4}>
          <TextFieldTK
            required
            fullWidth
            name="invitation.branch"
            label="¿En que rama?"
            placeholder="Escribe en que rama"
            value={getFormik('branch')?.value}
            onChange={formik.handleChange}
            disabled={isLoading}
            error={getFormik('branch')?.error}
            helperText={getFormik('branch')?.helperText}
            useTrim
          />
        </Grid>
      )}
    </Grid>
  );
};

export default InvitationForm;
